import { ActionReducerMap } from "@ngrx/store";
import { LayoutState, layoutReducer } from "./layouts/layout-reducers";
import { TicketReducer, TicketState } from "./Ticket/ticket_reducer";
import { TaskReducer, TaskState } from "./Task/task_reducer";
import { LoadDemandeAchatListReducer, LoadDemandeAchatListState } from "./achat/demande-achat/demande-achat-list.reducer";
import { DemandeAchatListEffects } from "./achat/demande-achat/demande-achat-list.effects";
// import { authenticationReducer, AuthenticationState } from "./Authentication/authentication.reducer";

export interface RootReducerState {
	layout: LayoutState;
	Ticket: TicketState;
	Task: TaskState;
	DemandAchatList: LoadDemandeAchatListState;
	// authentication: AuthenticationState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
	layout: layoutReducer,
	Ticket: TicketReducer,
	Task: TaskReducer,
	DemandAchatList: LoadDemandeAchatListReducer,
	// authentication: authenticationReducer,
};

//export const rootEffects = [DemandeAchatListEffects];
